export const OPTHINES = {
  voteName: '2021project/q4/2021enriching',
  mustSearch: 'Button',
  buttonBg: '#f4a842',
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: '#D20A0A',
    inactiveBgColor: '#B50B0B',
  },
  tabs: [
    {
      tabName: '候选人',
      tabPath: '/2019FMXY/first',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019FMXY/second',
    },
  ],
};
